import React from 'react';
import { BsDownload } from 'react-icons/bs';

import {
    HASHTAG_PDF_DOWNLOAD_LABEL,
    HASHTAG_PDF_GENERATING_LABEL,
} from '../../../utils/triviaResultsStrings';

const HashtagDownloadButton = ({ onClick, disabled, isBusy }) => {
    return (
        <button
            type="button"
            className="uc-export-btn uc-download-btn"
            onClick={onClick}
            disabled={disabled}
            aria-busy={!!isBusy}
        >
            <BsDownload /> {isBusy ? HASHTAG_PDF_GENERATING_LABEL : HASHTAG_PDF_DOWNLOAD_LABEL}
        </button>
    );
};

export default HashtagDownloadButton;
